export function subscribe(eventName, callback) {
  let cb = (event) => callback(event)

  document.addEventListener(eventName, cb)

  return function unsubscribe() {
    document.removeEventListener(eventName, cb)
  }
}

export function publish(eventName, options) {
  document.dispatchEvent(new CustomEvent(eventName, options))
}

export const EVENTS = {
  cartBeforeChange: 'cart:before-change',
  cartChange: 'cart:change',
  cartRendered: 'cart:rendered',
  cartError: 'cart:error',
  lineItemChange: 'line-item:change',
  variantChange: 'variant:change',
  qtyChange: 'qty:change',
  planChange: 'plan:change',
  sliderUpdate: 'slider:update',
  filtersUpdate: 'filters:update',
  filtersError: 'filters:error',
  loadMoreRequested: 'filters:load-more-requested',
  loadingStateChange: 'filters:loading-state-change',
  productsRendered: 'products:rendered',
  extraOptionSelected: 'extra-option:selected'
}